import { withState } from "@mna/react";
import AnimationThankYou2 from "features/Animation/ThankYou2";
import { Trans } from "react-i18next";
import LoadingScreen from "./LoadingScreen";
import { commonConstant } from "../server/triage/constants";
import { generateJsonWebToken, checkAndGetSessionStorageValue } from "../features/utils";

const Page = ({ state, actions, setState, history }) => (
  <div className="article-width align-item flex flex-column full-height pt-2">
    <LoadingScreen isLoading={state.isLoading}>
      <h1 className="text-center standby-page-header-title">
        {state.IsValidUser && state.isWhatsNext == false ? (
          <Trans i18nKey="findcareoption.Careoptions.Done.DoneScreenDeclineCareTitle"></Trans>
        ) : (
          <Trans i18nKey="findcareoption.Careoptions.Done.DoneScreenTitle"></Trans>
        )}
      </h1>
      <div className="standby-col standby-center">
        <AnimationThankYou2 />
      </div>

      <p
        className="standby-justify"
        dangerouslySetInnerHTML={{
          __html: state.isWhatsNext
            ? state.whatsNextContent
            : state.ThankYouContent,
        }}
      />

      {state.isWhatsNext ? (<div>
          <p
            className="standby-justify"
            dangerouslySetInnerHTML={{
              __html: state.userInstruction
              ,
            }}
          />
      </div>) : ""}

      <div className="done-space">
        <button
          type="button"
          className=" button standby-button-gradient standby-button-gradient-green"
          onClick={(e) => {
            if (state.IsValidUser) {
              if (state.isWhatsNext) {
                setState({
                  isWhatsNext: false,
                  isMenuClick:false,
                })

                e.preventDefault();

                actions.submitTriageSession();
                actions.clearTriageSession();
                history.push("/find-care-options/thank-you");
              }
              else
                history.push("/terms");
            } else {
              e.currentTarget.setAttribute("class", "hide");
              e.preventDefault();
              setState({isMenuClick:false})
              sessionStorage.setItem("IsValidUser", false);
              actions.submitTriageSession();
              actions.clearTriageSession();
              history.push("/find-care-options/thank-you");
            }
          }}
        >
          {state.IsValidUser && state.isWhatsNext == false ? (
            <Trans i18nKey="findcareoption.Careoptions.Done.startTriage">
              Start Triage
            </Trans>
          ) : (
            <Trans i18nKey="findcareoption.Careoptions.Done.done">DONE</Trans>
          )}
        </button>
      </div>
    </LoadingScreen>
  </div>
);

export default withState({
  async didMount({ state, actions, setState }) {
    window.store = store;
    setState({
      isWhatsNext: true,
    });
    if ( state.IsValidUser === undefined|| !state.IsValidUser) {
      setState({
        isTriageGoingForRegularUser: false,
      });
    }
    var data = actions.getReferenceData(state, setState, false, false);
    var jwtAccess_Token = generateJsonWebToken();
    var access_Token = checkAndGetSessionStorageValue("accessToken");
    
    // var command="search/speciality"+ data;
	  // var response = await actions.getNodeCallBack(state, setState, actions, command);
    var action = "getReferenceText";
    var response = await actions.sendTriageRequest({
    action: action,
    data: ({...data,  jwtAccessToken: jwtAccess_Token, accessToken: access_Token}),
    });

      if (response && response.message === commonConstant.success) {
          setState({
            isLoading: false,
            whatsNextContent:
              response.response,
          });
      } else {
        setState({
          isLoading: false,
          whatsNextContent: "",
        });
      }
      
      var userInstructionData = actions.getReferenceData(state, setState, false, true);
      var jwtAccess_Token = generateJsonWebToken();
      var access_Token = checkAndGetSessionStorageValue("accessToken");
      var action = "getReferenceText";
      var response = await actions.sendTriageRequest({
      action: action,
      data: ({...userInstructionData,  jwtAccessToken: jwtAccess_Token, accessToken: access_Token}),
    });
      if (response && response.message === commonConstant.success) {
        setState({
          isLoading: false,
          userInstruction:
            response.response,
        });
      } else {
        setState({
          isLoading: false,
          whatsNextContent: "",
          userInstruction: "",
        });
      }

    data = actions.getReferenceData(state, setState, true,false);
    var jwtAccess_Token = generateJsonWebToken();
    var access_Token = checkAndGetSessionStorageValue("accessToken");
    // var command="search/speciality"+ data;
	  // var response = await actions.getNodeCallBack(state, setState, actions, command);
    var action = "getReferenceText";
    var response = await actions.sendTriageRequest({
    action: action,
    data: ({...data,  jwtAccessToken: jwtAccess_Token, accessToken: access_Token}),
  });
  
      if (response && response.message === commonConstant.success) {
          setState({
            ThankYouContent:
              response.response,
          });
      } else {
        setState({
          ThankYouContent: "",
        });
      }
        setState({
          isLoading: false,
        });
  },
})(Page);
